import React from "react"
import SEO from "../components/seo"
import get from 'lodash/get';
import { graphql } from "gatsby"
import { FormattedMessage, useIntl } from "react-intl"
import Testimonials from "../components/testimonials/testimonials";
import Team from "../components/team/team";
import "./about.css"

// @TODO - update the links in the photo caption
// @TODO - image/rollovers sizes & urls

export default function AboutPage({ data }) {
  const { locale } = useIntl()
  const dataCosmicAbouts = get(data, 'allCosmicjsAbout')
  const post = dataCosmicAbouts.edges.find(({ node }) => node.locale === locale)?.node
  const partners = post.metadata.partnerships

  return (
    <section>
      <SEO title="About Us" />

      <section className="intro">
        <div className="inner inner-intro">
          <div className="lead component-lead component-lead-about">
            <h1 style={{ color: '#40777c' }}>{post.title}</h1>
            <h3 style={{ color: '#565656' }}>{post.metadata.subtitle}</h3>
          </div>
        </div>
      </section>

      <section className="about-story">
        <div className="inner inner-about inner-about-story">
          <hr style={{ marginTop: '-.5rem', marginBottom: '2.5rem' }} />
          <h2 className="about-title about-title-story h1" style={{ marginBottom: '3rem' }}><FormattedMessage
            id="about-our-story"
            defaultMessage="Our Story"
          /></h2>
          <div className="about-story-content">
            <p className="lead">{post.metadata.our_story_lead}</p>
            <div dangerouslySetInnerHTML={{ __html: post.metadata.our_story_text }} />
          </div>
          <div className="about-story-image">
            <img style={{ marginBottom: '1rem' }} src={`${post.metadata.featured_image.imgix_url}?q=&auto=compress,&w=888&h=690&fit=crop&crop=faces}`} alt="Inventing Heron Group" />
            <div dangerouslySetInnerHTML={{ __html: post.metadata.featured_image_caption }} />
          </div>
        </div>
      </section>

      {/* <Testimonials /> */}

      {/* <section className="about-partnerships">
        <div className="inner inner-about inner-about-partnerships">
          <hr style={{marginBottom: '3rem'}} />
          <h2 className="">Partnerships</h2>
          <ul>
            {partners.map((partner, idx) => (
              <li key={idx}>
                {partner.link_text}
              </li>
            ))}
          </ul>
        </div>
      </section> */}

      {/* <section className="about-team">
        <div className="inner inner-about inner-about-team">
          <hr style={{ marginTop: '-2.5rem', marginBottom: '3rem' }} />
          <h2 className="" style={{ textAlign: 'center' }}><FormattedMessage
            id="about-our-team"
            defaultMessage="Our Team"
          /></h2>
          <p style={{ marginBottom: '0rem', textAlign: 'center' }}>{post.metadata.our_team_intro_lead}</p>
          <p className="blockquote" style={{ marginBottom: '3rem', textAlign: 'center', color: '#e07306' }}>&ldquo;{post.metadata.our_team_quote_content}&rdquo;</p>
          <Team />
        </div>
      </section> */}

    </section>
  )
}

export const aboutQuery = graphql`
  {
    allCosmicjsAbout(filter: {slug: {eq: "about"}}) {
      edges {
        node {
          metadata {
            subtitle
            our_story_lead
            our_story_text
            featured_image_caption
            partnerships {
              link_text
              link_url
            }
            featured_image {
              imgix_url
            }
            our_team_intro_lead
            our_team_quote_content
          }
          title
          locale
        }
      }
    }
  }
`

// export const aboutQuery = graphql`
//   {
//     cosmicjsAbout(slug: {eq: "about"}) {
//       title
//       locale
//       metadata {
//         subtitle
//         our_story_lead
//         our_story_text
//         featured_image_caption
//         partnerships {
//           link_text
//           link_url
//         }
//         featured_image {
//           imgix_url
//         }
//         our_team_intro_lead
//         our_team_quote_content
//       }
//     }
//   }
// `
